<template>
    <div class="main-content">
        <div class="menu-items">
            <div v-if="!impersonating" class="account-menu">
                <div class="menu-item">
                    <button
                        type="button"
                        autofocus
                        @click="() => { navigateToSettings('billing'); emit('hidePopover'); }"
                        class="item-wrapper"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M17.5 3.75H2.5C2.08579 3.75 1.75 4.08579 1.75 4.5V15.5C1.75 15.9142 2.08579 16.25 2.5 16.25H17.5C17.9142 16.25 18.25 15.9142 18.25 15.5V4.5C18.25 4.08579 17.9142 3.75 17.5 3.75ZM17 5V6.25H3V5H17ZM3 15V7.5H17V15H3ZM4.375 13.125H6.875V11.875H4.375V13.125ZM4.375 10.625H8.125V9.375H4.375V10.625Z"
                                fill="currentColor"
                            />
                        </svg>
                        <span>Account billing</span>
                    </button>
                    <button
                        type="button"
                        @click="() => { navigateToSettings('controls'); emit('hidePopover'); }"
                        class="item-wrapper"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M9.9999 6.25003C9.25822 6.25003 8.5332 6.46996 7.91652 6.88202C7.29983 7.29407 6.81918 7.87974 6.53536 8.56496C6.25153 9.25019 6.17727 10.0042 6.32196 10.7316C6.46665 11.459 6.82381 12.1272 7.34825 12.6517C7.8727 13.1761 8.54089 13.5333 9.26832 13.678C9.99574 13.8227 10.7497 13.7484 11.435 13.4646C12.1202 13.1807 12.7059 12.7001 13.1179 12.0834C13.53 11.4667 13.7499 10.7417 13.7499 10C13.7489 9.00578 13.3535 8.05256 12.6504 7.34952C11.9474 6.64648 10.9941 6.25106 9.9999 6.25003ZM9.9999 12.5C9.50545 12.5 9.0221 12.3534 8.61098 12.0787C8.19986 11.804 7.87942 11.4135 7.69021 10.9567C7.50099 10.4999 7.45148 9.99725 7.54794 9.5123C7.6444 9.02735 7.88251 8.58189 8.23214 8.23226C8.58177 7.88263 9.02723 7.64453 9.51218 7.54806C9.99713 7.4516 10.4998 7.50111 10.9566 7.69033C11.4134 7.87955 11.8039 8.19998 12.0786 8.6111C12.3533 9.02222 12.4999 9.50557 12.4999 10C12.4999 10.6631 12.2365 11.299 11.7677 11.7678C11.2988 12.2366 10.6629 12.5 9.9999 12.5ZM18.589 8.37581C18.5716 8.2878 18.5354 8.20456 18.483 8.13177C18.4305 8.05897 18.363 7.99832 18.2851 7.95393L15.9546 6.62581L15.9452 3.99924C15.9449 3.90879 15.925 3.81947 15.8868 3.73746C15.8487 3.65545 15.7932 3.5827 15.7241 3.52424C14.8788 2.80916 13.9053 2.26117 12.8554 1.9094C12.7727 1.88142 12.6851 1.87106 12.5981 1.879C12.5112 1.88694 12.4269 1.913 12.3507 1.95549L9.9999 3.26956L7.64678 1.95315C7.57049 1.91041 7.48609 1.88416 7.39902 1.87608C7.31195 1.86801 7.22416 1.87829 7.14131 1.90628C6.09221 2.26062 5.11982 2.8107 4.27569 3.52737C4.20675 3.58574 4.15129 3.65836 4.11313 3.74023C4.07496 3.8221 4.05499 3.91126 4.05459 4.00159L4.04287 6.63049L1.7124 7.95862C1.63444 8.00301 1.56694 8.06366 1.5145 8.13646C1.46206 8.20925 1.42591 8.29248 1.4085 8.38049C1.19521 9.45228 1.19521 10.5556 1.4085 11.6274C1.42591 11.7154 1.46206 11.7986 1.5145 11.8714C1.56694 11.9442 1.63444 12.0049 1.7124 12.0492L4.04287 13.3774L4.05225 16.0039C4.05253 16.0944 4.07245 16.1837 4.11062 16.2657C4.14879 16.3477 4.20431 16.4205 4.27334 16.4789C5.11871 17.194 6.09221 17.742 7.14209 18.0938C7.22477 18.1218 7.31239 18.1321 7.39932 18.1242C7.48624 18.1162 7.57054 18.0902 7.64678 18.0477L9.9999 16.7305L12.353 18.0469C12.4462 18.0988 12.5511 18.1257 12.6577 18.125C12.726 18.125 12.7938 18.1139 12.8585 18.0922C13.9075 17.7383 14.8799 17.1888 15.7241 16.4727C15.7931 16.4143 15.8485 16.3417 15.8867 16.2598C15.9249 16.178 15.9448 16.0888 15.9452 15.9985L15.9569 13.3696L18.2874 12.0414C18.3654 11.997 18.4329 11.9364 18.4853 11.8636C18.5378 11.7908 18.5739 11.7076 18.5913 11.6196C18.8034 10.5486 18.8026 9.44643 18.589 8.37581ZM17.4171 11.1032L15.1851 12.3727C15.0873 12.4283 15.0063 12.5093 14.9507 12.6071C14.9054 12.6852 14.8577 12.768 14.8093 12.8461C14.7473 12.9446 14.7142 13.0586 14.714 13.175L14.7022 15.6946C14.1023 16.1657 13.4339 16.5424 12.7202 16.8117L10.4687 15.5571C10.3752 15.5053 10.27 15.4784 10.1632 15.4789H10.1483C10.0538 15.4789 9.9585 15.4789 9.86397 15.4789C9.75216 15.4761 9.64162 15.5031 9.54365 15.5571L7.29053 16.8149C6.5753 16.5476 5.90508 16.1727 5.30303 15.7032L5.29444 13.1875C5.29405 13.0709 5.26103 12.9567 5.19912 12.8578C5.15069 12.7797 5.10303 12.7016 5.0585 12.6188C5.00328 12.5195 4.92232 12.4369 4.82412 12.3797L2.58975 11.1071C2.47412 10.3757 2.47412 9.63064 2.58975 8.89925L4.81787 7.62737C4.91567 7.57176 4.99664 7.49079 5.05225 7.39299C5.09756 7.31487 5.14522 7.23206 5.19365 7.15393C5.25566 7.05541 5.28869 6.94143 5.28897 6.82503L5.30069 4.30549C5.90063 3.83436 6.56901 3.45762 7.28272 3.18831L9.53115 4.44299C9.62901 4.49724 9.73963 4.52422 9.85147 4.52112C9.946 4.52112 10.0413 4.52112 10.1358 4.52112C10.2476 4.52391 10.3582 4.49695 10.4562 4.44299L12.7093 3.18518C13.4245 3.45243 14.0947 3.82732 14.6968 4.2969L14.7054 6.81253C14.7058 6.92916 14.7388 7.04336 14.8007 7.14221C14.8491 7.22034 14.8968 7.29846 14.9413 7.38128C14.9965 7.48058 15.0775 7.56317 15.1757 7.62034L17.4101 8.89299C17.5272 9.62495 17.5285 10.3708 17.414 11.1032H17.4171Z"
                                fill="currentColor"
                            />
                        </svg>
                        <span>Account settings</span>
                    </button>
                    <a
                        href="https://support.privacybee.com/en-us/"
                        target="_blank"
                        @click="emit('hidePopover')"
                        class="item-wrapper"
                        aria-label="Help & support (opens in new tab)"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM13.0547 12.1711C13.5069 11.5375 13.7499 10.7784 13.7499 10C13.7499 9.22156 13.5069 8.46254 13.0547 7.82891L15.2813 5.60313C16.311 6.83689 16.8751 8.39295 16.8751 10C16.8751 11.607 16.311 13.1631 15.2813 14.3969L13.0547 12.1711ZM7.5 10C7.5 9.50555 7.64663 9.0222 7.92133 8.61107C8.19603 8.19995 8.58648 7.87952 9.04329 7.6903C9.50011 7.50108 10.0028 7.45157 10.4877 7.54804C10.9727 7.6445 11.4181 7.8826 11.7678 8.23223C12.1174 8.58186 12.3555 9.02732 12.452 9.51227C12.5484 9.99723 12.4989 10.4999 12.3097 10.9567C12.1205 11.4135 11.8001 11.804 11.3889 12.0787C10.9778 12.3534 10.4945 12.5 10 12.5C9.33696 12.5 8.70108 12.2366 8.23224 11.7678C7.7634 11.2989 7.5 10.663 7.5 10ZM14.3969 4.71875L12.1711 6.94531C11.5375 6.49312 10.7784 6.25006 10 6.25006C9.22156 6.25006 8.46254 6.49312 7.82891 6.94531L5.60313 4.71875C6.83689 3.68898 8.39296 3.12492 10 3.12492C11.607 3.12492 13.1631 3.68898 14.3969 4.71875ZM4.71875 5.60313L6.94532 7.82891C6.49312 8.46254 6.25006 9.22156 6.25006 10C6.25006 10.7784 6.49312 11.5375 6.94532 12.1711L4.71875 14.3969C3.68899 13.1631 3.12493 11.607 3.12493 10C3.12493 8.39295 3.68899 6.83689 4.71875 5.60313ZM5.60313 15.2812L7.82891 13.0547C8.46254 13.5069 9.22156 13.7499 10 13.7499C10.7784 13.7499 11.5375 13.5069 12.1711 13.0547L14.3969 15.2812C13.1631 16.311 11.607 16.8751 10 16.8751C8.39296 16.8751 6.83689 16.311 5.60313 15.2812Z"
                                fill="currentColor"
                            />
                        </svg>
                        <span>Help & support</span>
                    </a>
                    <button
                        type="button"
                        @click="() => { navigateToUniversity(); emit('hidePopover'); }"
                        class="item-wrapper"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M19.6688 6.94846L10.2938 1.94846C10.2034 1.90031 10.1025 1.87512 10 1.87512C9.8976 1.87512 9.79673 1.90031 9.7063 1.94846L0.331299 6.94846C0.231302 7.00175 0.147674 7.08122 0.0893613 7.17838C0.0310483 7.27553 0.000244141 7.38671 0.000244141 7.50002C0.000244141 7.61333 0.0310483 7.72451 0.0893613 7.82166C0.147674 7.91882 0.231302 7.99829 0.331299 8.05158L2.50005 9.20861V12.9914C2.4994 13.2984 2.61238 13.5948 2.81724 13.8235C3.84067 14.9633 6.13364 16.875 10 16.875C11.282 16.8856 12.5544 16.6534 13.75 16.1906V18.75C13.75 18.9158 13.8159 19.0748 13.9331 19.192C14.0503 19.3092 14.2093 19.375 14.375 19.375C14.5408 19.375 14.6998 19.3092 14.817 19.192C14.9342 19.0748 15 18.9158 15 18.75V15.5867C15.8151 15.1163 16.5515 14.5213 17.1829 13.8235C17.3877 13.5948 17.5007 13.2984 17.5 12.9914V9.20861L19.6688 8.05158C19.7688 7.99829 19.8524 7.91882 19.9107 7.82166C19.969 7.72451 19.9999 7.61333 19.9999 7.50002C19.9999 7.38671 19.969 7.27553 19.9107 7.17838C19.8524 7.08122 19.7688 7.00175 19.6688 6.94846ZM10 15.625C6.61958 15.625 4.6313 13.9735 3.75005 12.9914V9.87502L9.7063 13.0516C9.79673 13.0997 9.8976 13.1249 10 13.1249C10.1025 13.1249 10.2034 13.0997 10.2938 13.0516L13.75 11.2086V14.8289C12.7657 15.2883 11.525 15.625 10 15.625ZM16.25 12.9883C15.8754 13.404 15.4562 13.7774 15 14.1016V10.5414L16.25 9.87502V12.9883ZM14.6875 9.29221L14.6704 9.28205L10.2954 6.94846C10.1494 6.8739 9.97998 6.85967 9.82362 6.90882C9.66726 6.95798 9.53647 7.06659 9.45942 7.21126C9.38238 7.35593 9.36524 7.52507 9.41171 7.68225C9.45818 7.83943 9.56454 7.97207 9.70786 8.05158L13.3594 10L10 11.7914L1.95317 7.50002L10 3.20861L18.0469 7.50002L14.6875 9.29221Z"
                                fill="currentColor"
                            />
                        </svg>
                        <span>Privacy Bee University</span>
                    </button>
                </div>
            </div>
            <div v-if="authStore.user?.managed_accounts?.length" class="switch-account">
                <div class="switch-title">
                    <span>Impersonate</span>
                    <a
                        class="text-zinc-300 hover:text-zinc-500"
                        @mouseenter="handleEnter"
                        @mouseleave="handleLeave"
                        @click="handleClick"
                        href="https://support.privacybee.com/en-us/category/family-account-management-p780mq/"
                        target="_blank"
                        aria-label="Support article (opens in new tab)"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM9.6875 5.625C9.87292 5.625 10.0542 5.67998 10.2084 5.783C10.3625 5.88601 10.4827 6.03243 10.5536 6.20373C10.6246 6.37504 10.6432 6.56354 10.607 6.7454C10.5708 6.92725 10.4815 7.0943 10.3504 7.22541C10.2193 7.35652 10.0523 7.44581 9.8704 7.48199C9.68854 7.51816 9.50004 7.49959 9.32874 7.42864C9.15743 7.35768 9.01101 7.23752 8.908 7.08335C8.80499 6.92918 8.75 6.74792 8.75 6.5625C8.75 6.31386 8.84878 6.0754 9.02459 5.89959C9.20041 5.72377 9.43886 5.625 9.6875 5.625ZM10.625 14.375C10.2935 14.375 9.97554 14.2433 9.74112 14.0089C9.5067 13.7745 9.375 13.4565 9.375 13.125V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75C9.70652 8.75 10.0245 8.8817 10.2589 9.11612C10.4933 9.35054 10.625 9.66848 10.625 10V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375Z"
                                fill="currentColor"
                            />
                        </svg>
                    </a>
                </div>
                <div class="impersonate-list">
                    <button
                        type="button"
                        class="account-item"
                        v-for="user in usersImpersonate"
                        :key="user.id"
                        :aria-pressed="personStore.person?.id === user.id"
                        :aria-label="`Impersonate ${personDisplayName(user)}`"
                        @click="handleImpersonate(user.id)"
                    >
                        <PersonAvatar :name="personDisplayName(user)" :avatar-url="user.avatar_url" />
                        <div class="acc-wrapper">
                            <div class="name-div">
                                <span>{{ personDisplayName(user) }}</span>
                                <p>{{ user.license }}</p>
                            </div>
                            <!-- A real radio input cannot be nested inside this button, so the
                                 selected-account state is drawn and announced via aria-pressed. -->
                            <div class="impersonate-radio" aria-hidden="true">
                                <div class="impersonate-radio-box" :class="{ 'is-checked': personStore.person?.id === user.id }">
                                    <div class="impersonate-radio-dot" />
                                </div>
                            </div>
                        </div>
                    </button>
                </div>
            </div>

            <div v-if="impersonating" class="stop-impersonation">
                <PrimeButton
                    @click="handleEndImpersonation()"
                    label="Stop impersonating"
                    class="w-full"
                    autofocus
                    aria-label="Stop impersonating"
                />
            </div>
            <!-- Shown and acted on from the same gate, so the offer always matches the person the
                 popover is standing on rather than the signed-in buyer. -->
            <div v-else-if="gate !== 'allowed'" class="upgrade-div">
                <PrimeButton
                    @click="promptForGate(gate)"
                    label="Begin protection"
                    class="w-full"
                    tabindex="0"
                    aria-label="Begin protection"
                />
            </div>
            <button
                type="button"
                class="footer-div"
                @click="$router.push('/auth/logout')"
            >
                <div class="footer-content">
                    <svg
                        class="text-gray-50 lg:text-zinc-400"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                    >
                        <path
                            d="M13.3333 14.1667L17.5 10M17.5 10L13.3333 5.83333M17.5 10H7.5M7.5 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V13.5C2.5 14.9001 2.5 15.6002 2.77248 16.135C3.01217 16.6054 3.39462 16.9878 3.86502 17.2275C4.3998 17.5 5.09987 17.5 6.5 17.5H7.5"
                            stroke="currentColor"
                            stroke-width="1.67"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                    <span>Sign out</span>
                </div>
            </button>
        </div>
    </div>
</template>
<script setup lang="ts">
import { personDisplayName } from '@privacy-bee/format/text';
import PersonAvatar from '~/components/main/shared/PersonAvatar.vue';
import { useAuthStore } from '~/stores/auth';
import type { ManagedAccount } from '~/types/auth/auth';
import { useMobileStore } from '~/stores/layout/mobile';

const emit = defineEmits(['hidePopover']);

const mobileStore = useMobileStore();
const authStore = useAuthStore();
const route = useRoute();
const personStore = usePersonStore();
const router = useRouter();
const { gate, promptForGate } = useLicenseAccess();

const { impersonating } = storeToRefs(personStore);

const popover = ref<any>(null);

const { isMobile } = useIsMobile();

const isPhone = () => window.matchMedia('(max-width: 768px)').matches;

const handleEnter = (event: Event) => {
    if (!isPhone()) {
        event.stopPropagation();
        popover.value?.show(event);
    }
};

const handleLeave = () => {
    if (!isPhone()) {
        popover.value?.hide();
    }
};

const handleClick = (event: Event) => {
    if (isPhone()) {
        event.stopPropagation();
        popover.value?.toggle(event);
    }
};

const usersImpersonate = computed<ManagedAccount[]>(() => authStore.user?.managed_accounts ?? []);

/**
 * Navigate to settings page while preserving impersonation
 */
const navigateToSettings = (tab?: string) => {
    const query: Record<string, any> = { ...route.query };
    const path = tab ? `/settings/${tab}` : '/settings';
    router.push({ path, query });
};

/**
 * Navigate to university page while preserving impersonation
 */
const navigateToUniversity = () => {
    router.push({ path: '/university', query: route.query });
};

// The store runs the whole switch, loader, landing on the dashboard and the word on a failure included. The menu closes
// only on a switch that took: after a failure the member is still choosing.
const handleImpersonate = async (id: number) => {
    if (!(await personStore.startImpersonation(id))) {
        return;
    }

    emit('hidePopover');

    if (isMobile.value) {
        mobileStore.closeMobileNav();
    }
};

const handleEndImpersonation = async () => {
    await personStore.endImpersonation();
    emit('hidePopover');
};
</script>
<style lang="scss" scoped>
.main-content {
    @apply flex w-full lg:w-72 mt-2 flex-col items-start rounded-lg border-gray-200 bg-rail-raised lg:bg-gray-50;

    .menu-items {
        @apply flex flex-col items-start self-stretch rounded-lg border lg:border-zinc-200 bg-rail-raised lg:bg-white;

        .account-menu {
            @apply flex flex-col items-start gap-0.5 self-stretch py-1.5 border-b border-zinc-700 lg:border-gray-200;

            .menu-item {
                @apply flex flex-col items-start self-stretch px-1.5;

                .item-wrapper {
                    @apply flex items-center gap-2 p-2 flex-1 cursor-pointer w-full;
                    @apply bg-transparent border-0 text-left;

                    svg {
                        color: var(--ink-faint);
                    }

                    &:hover {
                        @apply bg-zinc-800 lg:bg-gray-100;
                    }
                    span {
                        @apply flex-1 h-5 text-ink-invert lg:text-zinc-700;
                        @apply text-sm font-semibold leading-5;
                    }
                }
            }
        }
    }

    .switch-account {
        @apply flex flex-col items-start gap-0.5 py-1.5 self-stretch rounded-b-lg;
        @apply border-b border-zinc-700 lg:border-gray-200;

        .switch-title {
            @apply flex items-start self-stretch pt-1.5 pr-3 pb-1 pl-3;

            span {
                @apply flex-1 text-zinc-400 lg:text-zinc-600 text-xs font-semibold leading-5;
            }
        }

        .impersonate-list {
            @apply flex flex-col items-start gap-0.5 self-stretch overflow-y-auto;
            max-height: 198px; // ~3 account items visible before scrolling
        }
    }
}

.account-item {
    @apply flex p-3 w-full cursor-pointer items-start gap-4 rounded-lg bg-rail-raised lg:bg-white w-full;
    @apply border-0 text-left;

    &:hover {
        @apply bg-zinc-800 lg:bg-gray-100;
    }

    .icon-div {
        @apply flex justify-center items-center w-10 h-10 p-2 aspect-square rounded-full border border-gray-200 bg-gray-100;
    }

    .acc-wrapper {
        @apply flex justify-between items-center flex-1;

        .name-div {
            @apply flex flex-col items-start;

            span {
                @apply text-ink-invert lg:text-gray-900 text-sm font-semibold leading-5;
            }
            p {
                @apply text-zinc-400 lg:text-gray-600 text-sm font-normal leading-5;
                @apply overflow-hidden text-ellipsis line-clamp-1;
            }
        }

        .icon-drop {
            @apply flex w-8 h-8 p-1.5 justify-center items-center content-center flex-wrap;
        }

        // Radio-style selection dot, defined here so a preset change cannot silently restyle it.
        .impersonate-radio {
            @apply relative inline-flex align-bottom cursor-pointer select-none rounded-lg border border-zinc-300 bg-white;

            .impersonate-radio-box {
                @apply flex h-4 w-4 items-center justify-center rounded-full duration-200 ease-in-out;

                &.is-checked {
                    @apply rounded-lg border border-blue-600 bg-blue-600 p-1 outline outline-1 outline-blue-600;
                }
            }

            .impersonate-radio-dot {
                @apply h-1.5 w-1.5 flex-shrink-0 rounded-full bg-white;
            }
        }
    }
}
.footer-div {
    @apply flex flex-col items-start gap-0.5 pt-1 pb-1.5 px-1.5 self-stretch w-full;
    @apply rounded-b-lg cursor-pointer bg-rail-raised lg:bg-gray-100;
    @apply border-0 text-left;
    
    &:hover {
        @apply scale-[1.02] bg-zinc-800 lg:bg-gray-200;
    }
    .footer-content {
        @apply flex items-center gap-3 p-2 flex-1 gap-2;

        span {
            @apply h-5 flex-1 text-ink-invert lg:text-zinc-700 text-sm font-semibold leading-5;
        }
    }
}
.upgrade-div {
    @apply flex flex-col items-center gap-0.5 pt-3 pb-3 px-6 self-stretch;
    @apply rounded-b-lg border-b border-zinc-700 lg:border-gray-200;
}
.stop-impersonation {
    @apply flex flex-col items-start gap-2.5 py-2 px-3.5 self-stretch border-b border-zinc-700 lg:border-gray-200 py-2 px-3;
}

.info {
    @apply bg-zinc-600 text-ink-invert text-xs font-semibold px-3 py-2 rounded -mt-14;
}
</style>
